import { useEffect, useState } from "react";
import { UserStatus } from "../../api/types/enums";
import { useAuthState } from "@riotgames/riotbar-react";
import { usePageMetadata } from "../../../../context/PageMetadata";
import { fetchData } from "../../api/api";
import { UserStatusSummarySchema } from "../../api/types/responses";
import { generateEndpointsByID } from "../../api/types/endpoints";
import { getUserStatusFromResponse } from "../../../../functional/userStatusUtils";
import { XSSOState, useXSSO } from "./useXSSO";
import { monitoring } from "../monitoring";
export const useUserStatus = ({ campaignID }) => {
    const { isAuthenticated } = useAuthState();
    const { xssoState } = useXSSO();
    const { environment } = usePageMetadata();
    const [isLoading, setIsLoading] = useState(true);
    const [userStatusSummary, setUserStatusSummary] = useState(undefined);
    const [userStatus, setUserStatus] = useState(UserStatus.Unverified);
    const [inviteCode, setInviteCode] = useState(undefined);
    const [betaKey, setBetaKey] = useState(undefined);
    useEffect(() => {
        const fetchUserStatusSummary = async () => {
            try {
                if (campaignID === "ERROR") {
                    throw new Error("Invalid Campaign ID");
                }
                const { hostname } = window.location;
                const { USER_STATUS_ENDPOINT } = generateEndpointsByID({ campaignID, environment, hostname });
                const response = await fetchData({
                    endpoint: USER_STATUS_ENDPOINT,
                    method: "GET",
                });
                const data = UserStatusSummarySchema.parse(response);
                setUserStatusSummary(data);
            }
            catch (e) {
                monitoring.logError(e, "Error fetching user status summary");
                setUserStatus(UserStatus.Unverified);
                setIsLoading(false);
            }
        };
        if (xssoState === XSSOState.LoginRequired ||
            (xssoState === XSSOState.PollAborted && !userStatusSummary) ||
            xssoState === XSSOState.TooSoon) {
            console.warn("Determined that a user needs to log in - cancelling loading spinner");
            setUserStatus(UserStatus.Unverified);
            setIsLoading(false);
        }
        if (userStatus === UserStatus.Unverified && isAuthenticated === true && !userStatusSummary) {
            fetchUserStatusSummary();
        }
    }, [userStatusSummary, environment, isAuthenticated, campaignID, xssoState, userStatus]);
    useEffect(() => {
        if (userStatusSummary) {
            setUserStatus(getUserStatusFromResponse(userStatusSummary));
            setInviteCode(userStatusSummary.inviteCode);
            if (userStatusSummary.keys && userStatusSummary.keys.length > 0) {
                setBetaKey(userStatusSummary.keys[0]);
            }
            setIsLoading(false);
        }
    }, [userStatusSummary]);
    return { isLoading, userStatus, inviteCode, betaKey };
};
//# sourceMappingURL=useUserStatus.js.map